import React, { useContext, useEffect, useState } from "react"
import { Button, Card, CardBody, CardImg, CardText, CardTitle, Col, Row } from "reactstrap"

import api from "../../../../../../services/api"
import { SelecionarModeloModal } from "./modals/SelecionarModeloModal"
import useModal from "./modals/useModal"
import { EditarModeloModal } from "./modals/EditarModeloModal"
import EmpresaContext from "../../../../../../contexts/Empresa"

export interface ModeloSite {
	id: number
	link: string
	tipo_modelo: "afiliacao" | "indicacao"
	params_map: string
}

interface ParametroSite {
	id: number
	chave: string
	valor: string
	descricao: string
	usuario_modelo_site_id: string
}

interface ModeloSiteParams {
	id: string
	modelo_site_id: number
	parametroSite: ParametroSite[]
	site: ModeloSite
	short_url?: string
}
export interface UsuarioModeloSite extends ModeloSiteParams {
	user_empresa_id: number
}
export interface EmpresaModeloSite extends ModeloSiteParams {
	empresa_id: number
}

interface PaginaIndicacaoProps {
	preview: string
	link: string
}

export interface Sites {
	afiliacao: UsuarioModeloSite
	indicacao: PaginaIndicacaoProps
}

export function Paginas() {
	const [paginaAfiliacao, setPaginaAfilicao] = useState<UsuarioModeloSite>()
	const [paginaIndicacao, setPaginaIndicacao] = useState<PaginaIndicacaoProps>()
	const [isModalVendedorVisible, setIsModalVendedorVisible] = useModal()

	const { empresaSelecionada } = useContext(EmpresaContext)

	async function carregarSiteUsuario() {
		try {
			const { data } = await api.get<Sites>("/marketing/modelos-sites/usuario")

			setPaginaAfilicao(data.afiliacao)

			setPaginaIndicacao(data.indicacao)
		} catch (error) {
			console.error("Houve um erro ao carregar os dados do site.", error)
		}
	}

	useEffect(() => {
		carregarSiteUsuario()
	}, [])

	const previewVendedor = paginaAfiliacao?.site?.link

	return (
		<>
			<SelecionarModeloModal
				isOpen={isModalVendedorVisible}
				onClose={setIsModalVendedorVisible}
				reload={carregarSiteUsuario} // Função para atualizar dados no front quando salvar
				paginaAfiliacao={paginaAfiliacao}
			/>

			<Row>
				<Col>
					<h2>
						Minhas páginas na{" "}
						<span className="text-capitalize">
							{empresaSelecionada?.nome.toLowerCase()}
						</span>
					</h2>
				</Col>
			</Row>
			<Row>
				<Col xs={12} sm={6}>
					<Card>
						<CardImg
							src={
								previewVendedor
									? previewVendedor + "preview.png"
									: "https://internal.playnee.com/vendedor/capa.png"
							}
						/>
						<CardBody>
							<CardTitle tag="h3">
								Página do Vendedor - Programa de Afiliação
							</CardTitle>
							<CardText style={{ display: "flex", gap: ".5rem" }}>
								<Button
									style={{ width: "100%" }}
									color="primary"
									disabled={!paginaAfiliacao?.id}
									onClick={() => {
										navigator.clipboard.writeText(
											paginaAfiliacao?.short_url
												? `https://playnee.com/vendedor/?u=${paginaAfiliacao.short_url}`
												: previewVendedor + `?UMS=${paginaAfiliacao?.id}`
										)
									}}
								>
									Copiar Link
								</Button>
								<Button
									style={{ width: "100%" }}
									color="primary"
									onClick={setIsModalVendedorVisible}
								>
									Selecionar Modelo
								</Button>
							</CardText>
						</CardBody>
					</Card>
				</Col>

				<Col xs={12} sm={6}>
					<Card>
						<CardImg src={paginaIndicacao?.preview} />
						<CardBody>
							<CardTitle tag="h3">Programa de Indicação</CardTitle>
							<CardText>
								<Button
									color="primary"
									style={{ width: "100%" }}
									disabled={!paginaIndicacao}
									onClick={() => {
										navigator.clipboard.writeText(paginaIndicacao!.link)
									}}
								>
									Copiar Link
								</Button>
							</CardText>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</>
	)
}
